import RepositoryFactory from "../../admin/apis/index";
const Seo = RepositoryFactory.Seo;

export default {
  insertSeoMeta({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Seo.insertSeoMeta(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getSeoMeta({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Seo.getSeoMeta(payload);
        commit("SET_SEOMETA", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
